import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorsMessages } from '../../model/error-messge.model';

@Component({
  selector: 'app-error-form',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <span *ngIf="control && (!control.valid || control.touched || control.dirty)">
      <ng-container *ngIf="control.errors?.['required']">
        {{ name | translate }} {{ 'REQUIRED' | translate }} !
      </ng-container>

      <ng-container *ngIf="control.errors?.['minlength']">
        {{ name | translate }} {{ 'REQUIRED_MIN_LENGTH' | translate }}
        {{ minLength }}
      </ng-container>

      <ng-container *ngIf="control.errors?.['maxlength']">
        {{ name | translate }} {{ 'NOT_MORE_THAN' | translate }} {{ maxLength }}
      </ng-container>

      <ng-container *ngIf="control.errors?.['min']">
        {{ name | translate }} {{ 'NOT_LESS_THAN' | translate }} {{ min }}
      </ng-container>

      <ng-container *ngIf="control.errors?.['max']">
        {{ name | translate }} {{ 'NOT_MORE_THAN' | translate }} {{ max }}
      </ng-container>

      <ng-container *ngIf="control?.errors?.['email']">
        {{ 'VALID_EMAIL' | translate }}
      </ng-container>
    </span>
  `,
})
export class ErrorFormComponent {
  formValues: any;

  @Input() minLength: number = 8;
  @Input() maxLength: number = 24;
  @Input() name!: string;
  @Input() max: number = 20;
  @Input() min: number = 1;
  @Input() control!: AbstractControl | NgModel;
  @Input() messages: Partial<ErrorsMessages> = {};

  constructor() {}
}
